import React, {Component} from 'react';
import Api from '../Api';
import Container from 'react-bootstrap/Container';
import MetaTags from 'react-meta-tags';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Publicitat from './estructura/Publicitat'
import Spinner from 'react-bootstrap/Spinner'
import Alert from 'react-bootstrap/Alert'
import DetallParticipacio from './elementsResultats/DetallParticipacio';

class Participacio extends Component {

  state = {
    pantalla: 1,
    participacioTotal: [],
    participacio: []
  }


  //DADES ACTUALITZABLES
obteDades() {
 
  //Resultats
var baseURL = `resultats/participacioBergueda.php`;
var participacio;
Api.get(baseURL)
.then(res => {
    if (res.status===200){
        participacio = res.data;
        this.setState({participacio});
        
    } else this.setState({pantalla:3, missatge:res.data.missatge})
  }) 
.catch (error => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        this.setState({pantalla:3, missatge:error.response.data.missatge});
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
        this.setState({pantalla:3, missatge:"Error en connexió a l'API"});
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
        this.setState({pantalla:3, missatge:"No hi ha connexió a Internet"});
      }
      console.log(error.config);
  }) //si surt ERROR 40X

   //Resultats totals per comarca i Catalunya
baseURL = `resultats/participacioTotal.php`;
var participacioTotal;
Api.get(baseURL)
.then(res => {
    if (res.status===200){
        participacioTotal = res.data;
        this.setState({participacioTotal});
        
    } else this.setState({pantalla:3, missatge:res.data.missatge})
  }) 
.catch (error => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        this.setState({pantalla:3, missatge:error.response.data.missatge});
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
        this.setState({pantalla:3, missatge:"Error en connexió a l'API"});
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
        this.setState({pantalla:3, missatge:"No hi ha connexió a Internet"});
      }
      console.log(error.config);
  }) //si surt ERROR 40X

}

trobaParticipacioTotal(codi) {
  var objecteParticipacio;
  this.state.participacioTotal.forEach(element => {
      if (element.dadesElement.codi == codi) objecteParticipacio = element //99 és el codi de Catalunya
  });

  return objecteParticipacio;
}

trobaParticipacio(codi) {
  var objecteParticipacio;
  this.state.participacio.forEach(element => {
      if (element.dadesMunicipi.codi == codi) objecteParticipacio = element //99 és el codi de Catalunya
  });

  return objecteParticipacio;
}

trobaParticipacioTotalFinal(codi) {
  var objecteParticipacio;
  this.props.resultatsTotals.forEach(element => {
      if (element.dadesElement.codi == codi) objecteParticipacio = element.dadesElectorals //99 és el codi de Catalunya
  });

  return objecteParticipacio;
}

trobaParticipacioFinal(codi) {
  var objecteParticipacio;
  this.props.resultats.forEach(element => {
      if (element.dadesMunicipi.codi == codi) objecteParticipacio = element.dadesElectorals //99 és el codi de Catalunya
  });

  return objecteParticipacio;
}

componentDidMount() {
  this.obteDades();
}

    
render() {   

  if (this.state.participacio.length>0&&this.state.participacioTotal.length>0&&this.state.pantalla!==2) {
    this.setState({pantalla:2})
  }

  return (
    <div className="participacio">
        
        <MetaTags>
                    <title>Participació i meses constituides - Resultats eleccions al parlament de Catalunya 2021 a la comarca del Berguedà - Aquí Berguedà</title>
                    <meta name="description" content={"Consulta tots els resultats de Catalunya a les eleccions al Parlament de Catalunya 2021"} />
                    <meta property="og:title" content={"Resultats eleccions al Parlament de Catalunya 2021"} />
         </MetaTags> 
        
        <Container>
        {this.state.pantalla===1 &&
            <div className="carregant">
              <Spinner animation="grow" role="status" variant="primary"> 
                    <span className="sr-only">Carregant</span>
              </Spinner>
            </div>
        }

        {this.state.pantalla===2 &&
          <div>
            <h2>Meses constituïdes i participació</h2>  

            {/* Detall Participació Catalunya */}
            <DetallParticipacio nom="Catalunya" index={0} participacio={this.trobaParticipacioTotal(99)} resultatsFinals={this.trobaParticipacioTotalFinal(99)}/> 

            {/* Detall Participació Berguedà */}
            <DetallParticipacio nom="Berguedà" index={1} participacio={this.trobaParticipacioTotal(14)} resultatsFinals={this.trobaParticipacioTotalFinal(14)}/> 
          
            <Row><Col><Publicitat/></Col></Row>

            {this.props.municipis.map((municipi,index) => (

            <DetallParticipacio nom={municipi.nom} index={index} participacio={this.trobaParticipacio(municipi.codi_generalitat)} resultatsFinals={this.trobaParticipacioFinal(municipi.codi_generalitat)}/> 

            ))}
          
          </div>
        } 

        {this.state.pantalla===3 &&
          <div className="error">
              {/* Route ens enllaça a cada component */}
              <Alert variant='danger'>
              Error: {this.state.missatge}
            </Alert>

          </div>
        }

        </Container>
    </div>
  );
}

}

export default Participacio; 